import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DailyProgressReportPreviewPage } from './daily-progress-report-preview';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DirectivesModule } from '../../../directives/directives.module';
import { SignatureDateModalComponent } from '../signature-date-modal/signature-date-modal.component';
import { SharedModule } from '../../shared/shared.module';
import { PipesModule } from '../../../pipes/pipes.module';

@NgModule({
  declarations: [
    DailyProgressReportPreviewPage,
    SignatureDateModalComponent
  ],
    imports: [
        DirectivesModule,
        IonicPageModule.forChild(DailyProgressReportPreviewPage),
        PdfViewerModule,
        SharedModule,
        PipesModule,
    ],
  entryComponents: [
    SignatureDateModalComponent
  ]
})
export class DailyProgressReportPreviewPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/daily-progress-report/daily-progress-report-preview/daily-progress-report-preview.module.ts